import { RecurrenceSettingsBulkField } from '../../../../components/RecurrenceSettings'

import { FormData } from '../../types'

type Props = {
  inEditMode: boolean
}

export function RecurrenceSettings(props: Props) {
  const { inEditMode } = props

  return (
    <RecurrenceSettingsBulkField<'recurrenceSettings', FormData>
      name="recurrenceSettings"
      recurrenceSettingsBulkFieldProps={{
        uiFramework: 'tidal',
        inEditMode: inEditMode,
        testId: 'recurrence',
      }}
    />
  )
}
